import React, { FC, useEffect, useState } from 'react';
import { OrganizationsTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import {
  deleteBuyer,
  fetchBuyerConvenors,
  fetchBuyers,
  fetchBuyerSuperconvenors,
} from '../../../store/buyerAPI/buyer/reducers/buyer.slice';
import cn from 'classnames';
import styles from './OrganizationsPage.module.css';
import Spinner from '../../atoms/Spinner/Spinner';
import { BuyerResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-response.dto';

interface OrganizationsPageProps {}

const OrganizationsPage: FC<OrganizationsPageProps> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { buyers, conveners, consortiums, status } = useSelector(
    (state: RootState) => state.buyerSlice
  );

  const [combinedOrganizations, setCombinedOrganizations] = useState<
    BuyerResponseDto[]
  >([]);

  useEffect(() => {
    dispatch(fetchBuyers());
    dispatch(fetchBuyerConvenors());
    dispatch(fetchBuyerSuperconvenors());
  }, []);

  const handleDeleteOrganization = (id: string) => {
    dispatch(deleteBuyer(id));
  };

  useEffect(() => {
    const combined = [buyers, conveners, consortiums]
      .flat()
      .filter((item): item is BuyerResponseDto => item !== null);

    setCombinedOrganizations(combined);
  }, [buyers, conveners, consortiums]);

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <OrganizationsTemplate
        data={combinedOrganizations ?? []}
        handleDeleteOrganization={handleDeleteOrganization}
      />
    </div>
  );
};

export default OrganizationsPage;
